var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"block"},[_c('b-tooltip',{attrs:{"label":_vm.originalDate,"position":"is-bottom"}},[_vm._v("\n    "+_vm._s(_vm.timeAgo)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }